import React from 'react'
import {Input} from 'antd'

export default function TextAreaField() {
  return <Input rows={4} style={{height: '10rem'}} size="large"></Input>
}
